import React from "react";
import { Link } from "react-router-dom";
import { FileCheck } from "lucide-react";

const PROCESS_STATUS_LABELS = {
  AGUARDANDO_ANALISE: "Aguardando análise",
  AGUARDANDO_VALOR_OFICIO: "Aguardando valor do ofício",
  EM_ANALISE: "Em análise",
  ANALISE_FALHOU: "Falha na análise",
  ANALISADO: "Analisado",
  CONVERTIDO_LEAD: "Convertido em lead",
  REJEITADO: "Rejeitado",
  INVIAVEL: "Inviável",
  ARQUIVADO: "Arquivado",
};

export default function ConvertedToProcessBadge({
  processId,
  processStatus,
  compact = false,
  className = "",
  linkable = true,
}) {
  if (!processId) return null;

  const statusLabel = processStatus
    ? PROCESS_STATUS_LABELS[processStatus] || processStatus
    : null;
  const title = statusLabel
    ? `Publicação convertida em processo · ${statusLabel}`
    : "Publicação convertida em processo";

  const badge = (
    <span
      className={`inline-flex items-center gap-1 rounded-lg border border-emerald-200 bg-emerald-100 px-2 py-1 text-xs font-semibold text-emerald-800 ${className}`}
      title={title}
    >
      <FileCheck className="h-3 w-3 flex-shrink-0" />
      {compact ? "Processo" : "Convertida em processo"}
    </span>
  );

  if (!linkable) return badge;

  return (
    <Link
      to={`/processo/${processId}`}
      onClick={(event) => event.stopPropagation()}
      className="inline-flex hover:opacity-90 transition-opacity"
      title={title}
    >
      {badge}
    </Link>
  );
}
